export default {"src":"/_next/static/media/shield.f36ae933.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};